module.exports = __webpack_public_path__ + "img/aboutMob.51931144.png";